import { apiClientWithMiddleware } from '../../../../api/utils';
import { isSeleniumRunning } from '../../../../utils/analytics/utils/testEnv';
import getAppName from '../../../../utils/getAppName';
import getCurrentUrl from '../../../../utils/getCurrentUrl';
import { getLocale } from '../../../../utils/getLocale';
import { getPortalId } from '../../../../utils/getPortalId';
import strToRegExp from '../../../../utils/strToRegExp';
import { get } from '../../../../utils/tempStorage';
import { severityLevels } from '../FireAlarmBannerUtils';
export function sortAlarmsBySeverity(alarms) {
  const severityPriority = {
    [severityLevels.critSit]: 1,
    [severityLevels.outage]: 2,
    [severityLevels.maintenance]: 3,
    [severityLevels.debug]: 4
  };
  return alarms.sort((a, b) => {
    return severityPriority[a.severity] - severityPriority[b.severity];
  });
}
export const SHOW_DEBUG_ALARMS_KEY = 'firealarm.show.debug.alarms';
export const SELENIUM_ALARMS_DISABLE = 'selenium.disable.alarms';
const hasDebugLocalStorageValue = () => get(SHOW_DEBUG_ALARMS_KEY) === 'true';
const hasSeleniumDisableAlarmLocalStorageValue = () => get(SELENIUM_ALARMS_DISABLE) === 'true';
const matchesUrlPattern = pattern => {
  var _regEx$test;
  const regEx = strToRegExp(pattern);
  const url = getCurrentUrl();
  return (_regEx$test = regEx === null || regEx === void 0 ? void 0 : regEx.test(url)) !== null && _regEx$test !== void 0 ? _regEx$test : false;
};
export const filterAlarms = alarms => {
  if (isSeleniumRunning() && hasSeleniumDisableAlarmLocalStorageValue()) {
    console.warn(`Selenium is running, and "${SELENIUM_ALARMS_DISABLE}" key present, disabling fire alarms. Unset "${SELENIUM_ALARMS_DISABLE}" in localStorage to enable.`);
    return [];
  }
  return alarms.filter(alarm => {
    if (alarm.debug && !hasDebugLocalStorageValue()) {
      return false;
    }
    if (alarm.urlRegexPattern && !matchesUrlPattern(alarm.urlRegexPattern)) {
      return false;
    }
    return true;
  });
};
export function getFireAlarms() {
  const appName = getAppName();
  const portalId = getPortalId();
  const lang = getLocale();
  const url = `firealarm/v4/alarm/${appName}/${portalId || ''}?lang=${lang}`;
  return apiClientWithMiddleware().get(url);
}